/**
 * Имена рыб и приметы вида: русский.
 *
 * ⚠️ ОТДЕЛЬНЫМ ФАЙЛОМ, А НЕ В ru.ts, И ЭТО ВЫНУЖДЕННО. Сто видов — это двести
 * строк на язык и около семнадцати килобайт. Словарь и без них весит 36 КБ
 * при пределе в 100, а после четырёх таких прибавок правка любой надписи меню
 * означала бы прокрутку через полсотни рыб. Здесь же лежит ровно одно —
 * названия и приметы, — и переводчику видно, что ещё не сделано.
 *
 * ⚠️ ЛАТЫНИ ЗДЕСЬ НЕТ, И ЭТО НЕ ПРОПУСК. `Esox lucius` одинаков во всех
 * четырёх языках: держи мы его в словарях, одна и та же строка лежала бы
 * четырежды и расходилась бы при опечатке. Латынь живёт в описании вида
 * (sim-fish/species-planned.ts) вместе с остальными сведениями о рыбе.
 *
 * ⚠️ ПРИМЕТА ОТВЕЧАЕТ НА ОДИН ВОПРОС: «Я это поймал — кто это?» Поэтому в ней
 * сперва то, что видно в руке (форма, цвет, рот, плавники), и только потом —
 * где стоит. Повадки боя, вес и горизонт сюда не пишутся: они есть числами,
 * и два места об одном обязательно разойдутся.
 */
export const РЫБЫ_RU: Record<string, string> = {
  // ── карповые ────────────────────────────────────────────────────────────
  'fish.bream': 'лещ',
  'fish.bream_look':
    'Высокий, плоский как ладонь, тёмно-бронзовый. Стоит стаей на илистых плёсах и у выхода из ям.',
  'fish.silver_bream': 'густера',
  'fish.silver_bream_look':
    'Похожа на подлещика, но плавники с красниной, а чешуя крупнее. Держится у самого дна.',
  'fish.blue_bream': 'синец',
  'fish.blue_bream_look':
    'Узкий и высокий, с синеватой спиной и длинным анальным плавником. Ходит в толще воды.',
  'fish.white_bream': 'белоглазка',
  'fish.white_bream_look':
    'Серебристая, с большим мутно-белым глазом и тупым рылом. Любит течение на песке.',
  'fish.carp': 'карп',
  'fish.carp_look':
    'Толстый, золотисто-бурый, с двумя парами усов. Роет дно на мели, выдавая себя мутью.',
  'fish.wild_carp': 'сазан',
  'fish.wild_carp_look':
    'Дикий карп: прогонистее, темнее и злее. Держится в коряжнике и у стены камыша.',
  'fish.crucian': 'карась',
  'fish.crucian_look':
    'Круглый, золотистый, без усов. Стоит в травяных заливах и заиленных прудах.',
  'fish.gibel_carp': 'серебряный карась',
  'fish.gibel_carp_look':
    'Серебристый, площе золотого, спинной плавник с зазубриной. Живёт всюду, где есть вода.',
  'fish.roach': 'плотва',
  'fish.roach_look':
    'Серебряная, с красным глазом и оранжевыми плавниками. Стоит стайкой у травы.',
  'fish.kutum': 'кутум',
  'fish.kutum_look':
    'Крупная тёмная плотва каспийских рек, с толстыми губами. Кормится ракушкой на косах.',
  'fish.rudd': 'краснопёрка',
  'fish.rudd_look':
    'Золотистая, с алыми плавниками и вздёрнутым ртом. Кормится у поверхности над травой.',
  'fish.ide': 'язь',
  'fish.ide_look':
    'Толстый, светло-бронзовый, с малиновыми плавниками. Стоит на границе течения и тиши.',
  'fish.chub': 'голавль',
  'fish.chub_look':
    'Широколобый, с крупной тёмной чешуёй и алым хвостом. Держится под нависшими кустами.',
  'fish.dace': 'елец',
  'fish.dace_look': 'Мелкий, серебристый, с узким телом и прямым ртом. Стоит на песчаных перекатах.',
  'fish.tench': 'линь',
  'fish.tench_look':
    'Тёмно-зелёный, в слизи, с крохотными усиками и красным глазом. Копается в тине у камыша.',
  'fish.nase': 'подуст',
  'fish.nase_look':
    'Тёмная спина, нижний поперечный рот, чёрная брюшина. Скоблит камни на быстрине.',
  'fish.barbel': 'усач',
  'fish.barbel_look':
    'Прогонистое тело, четыре уса, нижний рот. Лежит на дне быстрых каменистых участков.',
  'fish.dnieper_barbel': 'днепровский усач',
  'fish.dnieper_barbel_look':
    'Усач днепровских порогов, темнее и короче обычного. Держится за камнями на струе.',
  'fish.grass_carp': 'белый амур',
  'fish.grass_carp_look':
    'Длинный, вальковатый, с широким лбом. Пасётся в зарослях, срезая молодой камыш.',
  'fish.black_carp': 'чёрный амур',
  'fish.black_carp_look':
    'Тёмный, почти чугунный, с мощными глоточными зубами. Дробит ракушку на дне.',
  'fish.silver_carp': 'белый толстолобик',
  'fish.silver_carp_look':
    'Серебристый, лоб широкий, глаза посажены низко. Ходит в толще и выпрыгивает от шума.',
  'fish.bighead_carp': 'пёстрый толстолобик',
  'fish.bighead_carp_look':
    'Крупнее белого, в тёмных пятнах, голова огромная. Держится в толще над ямами.',
  'fish.vimba': 'рыбец',
  'fish.vimba_look':
    'Прогонистая, с горбатым носом и тёмной спиной. Идёт стаей вверх по течению.',
  'fish.sabrefish': 'чехонь',
  'fish.sabrefish_look':
    'Плоская сабля: спина прямая, брюхо выгнуто, рот верхний. Бьёт малька в толще на струе.',
  'fish.shemaya': 'шемая',
  'fish.shemaya_look':
    'Узкая серебряная рыбка с тёмной спинкой. Кормится у поверхности на течении.',
  'fish.bleak': 'уклейка',
  'fish.bleak_look': 'Мелкая, ярко-серебряная, рот верхний. Толчётся у поверхности всей стаей.',
  'fish.moderlieschen': 'верховка',
  'fish.moderlieschen_look':
    'Крошечная, прозрачно-серебряная. Живёт у самой поверхности стоячих прудов.',
  'fish.gudgeon': 'пескарь',
  'fish.gudgeon_look': 'Пятнистый, с двумя усиками и плоским брюшком. Лежит на песке у переката.',
  'fish.schneider': 'быстрянка',
  'fish.schneider_look':
    'Похожа на уклейку, но вдоль бока идут две тёмные полоски. Держится на быстрой воде.',
  'fish.amur_bream': 'амурский лещ',
  'fish.amur_bream_look':
    'Лещ Амура: уже нашего, с прямой спиной и мелкой чешуёй. Ходит стаей по протокам.',
  'fish.volga_nase': 'волжский подуст',
  'fish.volga_nase_look':
    'Подуст волжских притоков, светлее днепровского. Скоблит камни на перекатах.',
  'fish.bitterling': 'горчак',
  'fish.bitterling_look':
    'Крохотный, высокий, с радужной полосой вдоль бока. Живёт там, где есть ракушки-беззубки.',
  'fish.amur_chebak': 'амурский чебак',
  'fish.amur_chebak_look':
    'Амурская плотва: серебряная, со спиной в темень. Стоит стаей в тихих протоках.',
  'fish.skygazer': 'верхогляд',
  'fish.skygazer_look':
    'Хищник с задранным вверх ртом и высокой спиной. Бьёт малька в толще Амура.',
  'fish.yellowcheek': 'желтощёк',
  'fish.yellowcheek_look':
    'Крупный амурский хищник с жёлтым пятном на щеке. Гоняет стаи на быстрине.',
  'fish.asp': 'жерех',
  'fish.asp_look':
    'Прогонистый, серебряный, с выступающей нижней челюстью. Бьёт малька на поверхности.',

  // ── лососёвые ───────────────────────────────────────────────────────────
  'fish.brown_trout': 'ручьевая форель',
  'fish.brown_trout_look':
    'Пятнистая, с красными точками в светлых ободках. Стоит в холодных ручьях за камнями.',
  'fish.lake_trout': 'озёрная форель',
  'fish.lake_trout_look':
    'Крупная серебристая форель глубоких озёр, пятна тёмные. Выходит на отмели к ночи.',
  'fish.rainbow_trout': 'радужная форель',
  'fish.rainbow_trout_look':
    'Серебряная, с розовой полосой вдоль бока и чёрным крапом. Держится в толще.',
  'fish.sea_trout': 'кумжа',
  'fish.sea_trout_look':
    'Проходная форель: в реке темнеет, с бурыми пятнами. Идёт вверх по течению на нерест.',
  'fish.salmon': 'сёмга',
  'fish.salmon_look':
    'Мощная, серебряная, с чёрными крестиками выше боковой линии. Стоит в ямах на пути нереста.',
  'fish.arctic_char': 'арктический голец',
  'fish.arctic_char_look':
    'Тёмная спина, светлые пятна без ободков, брюхо от розового до алого. Любит ледяную воду.',
  'fish.palia': 'палия',
  'fish.palia_look':
    'Голец глубоких северных озёр: тёмный, с белой каймой по краю нижних плавников.',
  'fish.taimen': 'таймень',
  'fish.taimen_look':
    'Огромный речной лосось с плоской головой и красным хвостом. Хозяин сибирских рек.',
  'fish.danube_salmon': 'дунайский лосось',
  'fish.danube_salmon_look':
    'Таймень Дуная: медно-бурый, в мелком крапе, хвост широкий. Стоит в глубоких плёсах.',
  'fish.marble_trout': 'мраморная форель',
  'fish.marble_trout_look':
    'Крупная форель балканских рек: бок в мраморных разводах, красных точек нет.',
  'fish.lenok': 'ленок',
  'fish.lenok_look': 'Тёмный, с мелким крапом и тупым рылом. Стоит на перекатах сибирских рек.',
  'fish.sevan_trout': 'севанская форель',
  'fish.sevan_trout_look':
    'Форель Севана: серебристая, с редкими тёмными пятнами. Держится на глубине озера.',

  // ── сиговые ─────────────────────────────────────────────────────────────
  'fish.whitefish': 'сиг',
  'fish.whitefish_look':
    'Серебристый, с нижним ртом и плотной мелкой чешуёй. Ходит стаей у дна холодных озёр.',
  'fish.vendace': 'ряпушка',
  'fish.vendace_look': 'Мелкий сиг с верхним ртом и синеватой спиной. Держится стаями в толще.',
  'fish.peled': 'пелядь',
  'fish.peled_look': 'Высокотелый сиг с тёмной головой и конечным ртом. Собирает рачка в толще.',
  'fish.omul': 'омуль',
  'fish.omul_look': 'Байкальский сиг: прогонистый, большеглазый. Ходит стаями следом за рачком.',
  'fish.broad_whitefish': 'чир',
  'fish.broad_whitefish_look':
    'Горбатый сиг северных рек, с толстой мордой и нижним ртом. Кормится на дне.',
  'fish.muksun': 'муксун',
  'fish.muksun_look':
    'Сиг сибирских рек: серебряный, с острым рылом. Держится в придонной толще.',
  'fish.nelma': 'нельма',
  'fish.nelma_look':
    'Белый лосось сиговых кровей: крупный, с большим ртом. Гоняет малька в реках Севера.',
  'fish.grayling': 'хариус',
  'fish.grayling_look':
    'Тёмная спина и огромный парусный плавник в пятнах. Стоит за камнями на струе.',
  'fish.siberian_grayling': 'сибирский хариус',
  'fish.siberian_grayling_look':
    'Крупнее европейского, парус ярче и с красной каймой. Держится на быстринах.',

  // ── окунёвые ────────────────────────────────────────────────────────────
  'fish.perch': 'окунь',
  'fish.perch_look':
    'Полосатый, с колючим спинным плавником и красными брюшными. Держится стайкой.',
  'fish.zander': 'судак',
  'fish.zander_look': 'Серебристо-серый, с клыками и колючим гребнем. Ходит по дну, у бровок и ям.',
  'fish.volga_zander': 'берш',
  'fish.volga_zander_look':
    'Похож на судака, но мельче, без клыков и с тупой мордой. Стоит на песчаных ямах.',
  'fish.ruffe': 'ёрш',
  'fish.ruffe_look': 'Колючий, серо-бурый в тёмных точках, весь в слизи. Лежит на дне в глубине.',
  'fish.donets_ruffe': 'носарь',
  'fish.donets_ruffe_look':
    'Ёрш с вытянутым рылом и желтоватой окраской. Держится на песке речных струй.',
  'fish.zingel': 'чоп',
  'fish.zingel_look':
    'Длинный, вальковатый, в тёмных перевязях, с двумя спинными плавниками. Прижат ко дну.',
  'fish.streber': 'малый чоп',
  'fish.streber_look':
    'Тоньше и мельче чопа, пятна на боку заметнее. Живёт на каменистых струях.',
  'fish.percarina': 'перкарина',
  'fish.percarina_look':
    'Крошечный полупрозрачный окунёк лиманов, глаза большие. Ходит стайками в толще.',

  // ── осетровые ───────────────────────────────────────────────────────────
  'fish.sterlet': 'стерлядь',
  'fish.sterlet_look':
    'Мелкий осётр с узким острым рылом и бахромчатыми усиками. Ходит по дну на течении.',
  'fish.russian_sturgeon': 'русский осётр',
  'fish.russian_sturgeon_look':
    'Тупорылый осётр с рядами костяных жучек по спине. Кормится на дне ям.',
  'fish.siberian_sturgeon': 'сибирский осётр',
  'fish.siberian_sturgeon_look':
    'Осётр сибирских рек: темнее русского, рыло короче. Держится у самого грунта.',
  'fish.stellate_sturgeon': 'севрюга',
  'fish.stellate_sturgeon_look':
    'Осётр с длинным мечевидным рылом и узким телом. Роется в песке на глубине.',
  'fish.beluga': 'белуга',
  'fish.beluga_look':
    'Самая крупная рыба пресных вод: огромная пасть, тупое рыло. Стоит в глубоких ямах.',
  'fish.ship_sturgeon': 'шип',
  'fish.ship_sturgeon_look':
    'Осётр со сплошной нижней губой — по виду между севрюгой и осетром.',
  'fish.kaluga': 'калуга',
  'fish.kaluga_look': 'Белуга Амура: великан с широкой пастью. Держится на дне больших плёсов.',
  'fish.paddlefish': 'веслонос',
  'fish.paddlefish_look':
    'Осетровый с длинным веслом вместо рыла. Процеживает рачка, идя в толще с открытым ртом.',

  // ── сомовые ─────────────────────────────────────────────────────────────
  'fish.catfish': 'сом',
  'fish.catfish_look':
    'Голое тёмное тело, широкая пасть, два длинных уса. Лежит в ямах и под завалами.',
  'fish.channel_catfish': 'канальный сомик',
  'fish.channel_catfish_look':
    'Пятнистый, с вильчатым хвостом и четырьмя парами усов. Ходит по дну стаей.',
  'fish.amur_catfish': 'косатка-скрипун',
  'fish.amur_catfish_look':
    'Небольшой сомик с жёлтыми полосами и колючими шипами. В руке скрипит.',
  'fish.clarias': 'клариас',
  'fish.clarias_look':
    'Угреватый сом с длинным спинным плавником, дышит воздухом. Держится в тёплой мутной воде.',

  // ── щуковые ─────────────────────────────────────────────────────────────
  'fish.pike': 'щука',
  'fish.pike_look':
    'Вытянутая, тёмно-зелёная с жёлтыми пятнами, пасть в зубах. Стоит в засаде у травы и коряг.',
  'fish.amur_pike': 'амурская щука',
  'fish.amur_pike_look':
    'Щука Амура: серебристая, в мелком тёмном крапе вместо жёлтых пятен. Стоит в протоках.',

  // ── центрарховые ────────────────────────────────────────────────────────
  'fish.pumpkinseed': 'солнечный окунь',
  'fish.pumpkinseed_look':
    'Пёстрый, круглый, с оранжевым пятном на жаберной крышке. Толчётся у травы.',
  'fish.largemouth_bass': 'большеротый окунь',
  'fish.largemouth_bass_look':
    'Зелёный, с тёмной полосой вдоль бока и пастью до глаза. Стоит в коряжнике.',
  'fish.smallmouth_bass': 'малоротый окунь',
  'fish.smallmouth_bass_look':
    'Бронзовый, с тёмными перевязями поперёк бока. Любит каменистое дно и струю.',

  // ── бычковые ────────────────────────────────────────────────────────────
  'fish.round_goby': 'бычок-кругляк',
  'fish.round_goby_look':
    'Тёмный, с чёрным пятном на спинном плавнике; брюшные срослись в присоску. Сидит на дне.',
  'fish.sand_goby': 'бычок-песочник',
  'fish.sand_goby_look':
    'Светлый, песочного цвета, бок в пятнышках. Держится на песчаных отмелях.',
  'fish.tubenose_goby': 'бычок-цуцик',
  'fish.tubenose_goby_look':
    'Крошечный, с трубочками ноздрей, торчащими над верхней губой. Живёт среди камней.',

  // ── вьюновые ────────────────────────────────────────────────────────────
  'fish.weatherfish': 'вьюн',
  'fish.weatherfish_look':
    'Длинный, змеевидный, в тёмных полосах, с десятью усиками. Дышит воздухом в затхлой воде.',
  'fish.spined_loach': 'щиповка',
  'fish.spined_loach_look':
    'Узкая, с рядом тёмных пятен и складным шипом под глазом. Зарывается в песок.',
  'fish.stone_loach': 'голец-усач',
  'fish.stone_loach_look': 'Гладкий, пятнистый, с шестью усиками. Прячется под камнями в ручьях.',

  // ── корюшковые ──────────────────────────────────────────────────────────
  'fish.smelt': 'корюшка',
  'fish.smelt_look':
    'Прозрачно-серебряная, во рту мелкие зубы, пахнет свежим огурцом. Ходит плотной стаей.',
  'fish.snetok': 'снеток',
  'fish.snetok_look': 'Мелкая озёрная корюшка длиной с палец. Держится стаями в холодной толще.',

  // ── миноговые ───────────────────────────────────────────────────────────
  'fish.river_lamprey': 'речная минога',
  'fish.river_lamprey_look':
    'Не рыба вовсе: змеевидная, без челюстей, с круглой присоской вместо рта.',
  'fish.ukrainian_lamprey': 'украинская минога',
  'fish.ukrainian_lamprey_look':
    'Мелкая минога ручьёв: взрослой не кормится вовсе. Личинки годами живут в иле.',

  // ── прочие ──────────────────────────────────────────────────────────────
  'fish.rotan': 'ротан',
  'fish.rotan_look':
    'Тёмный, головастый, с большим ртом. Захватывает мелкие пруды и выедает в них всё живое.',
  'fish.snakehead': 'змееголов',
  'fish.snakehead_look':
    'Змеиная голова в щитках, длинный спинной плавник. Дышит воздухом и стережёт свой выводок.',
  'fish.burbot': 'налим',
  'fish.burbot_look':
    'Единственная пресноводная треска: скользкая, пятнистая, с усиком на подбородке. Оживает в холод.',
  'fish.eel': 'угорь',
  'fish.eel_look':
    'Змеевидный, скользкий, с крошечными жаберными щелями. Ночью выходит на отмели, днём в иле.',
  'fish.bullhead': 'подкаменщик',
  'fish.bullhead_look':
    'Головастый, приплюснутый, в разводах, без чешуи. Сидит под камнями чистых ручьёв.',
  'fish.bigmouth_buffalo': 'большеротый буффало',
  'fish.bigmouth_buffalo_look':
    'Похож на крупного карася с толстой спиной, рот направлен вперёд. Кормится в толще.',
  'fish.smallmouth_buffalo': 'малоротый буффало',
  'fish.smallmouth_buffalo_look':
    'Темнее большеротого, рот нижний. Собирает корм прямо со дна.',
  'fish.tilapia': 'тиляпия',
  'fish.tilapia_look':
    'Высокотелая, в поперечных полосах, с длинным спинным плавником. Любит тёплую воду.',
};
